module.exports = __webpack_public_path__ + "img/company.6b41ac6f.svg";